"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductSource = getProductSource;
exports.sourceIsHubSpot = sourceIsHubSpot;
exports.sourceIsEcommApi = sourceIsEcommApi;
exports.getDealSource = getDealSource;
exports.getLineItemSource = getLineItemSource;
exports.getProductDescriptionProperty = getProductDescriptionProperty;
exports.getProductImageSource = getProductImageSource;
exports.getProductTagsProperty = getProductTagsProperty;
exports.getLineItemDiscountValue = getLineItemDiscountValue;
exports.getPriceProperty = getPriceProperty;
exports.getDealDiscountProperty = getDealDiscountProperty;
exports.getDealSubtotalProperty = getDealSubtotalProperty;
exports.getDealTaxProperty = getDealTaxProperty;

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _PropertyNames = require("customer-data-objects/lineItem/PropertyNames");

var _Integrations = require("products-ui-components/constants/Integrations");

var _ProductProperties = require("customer-data-objects/product/ProductProperties");

function getProductSource(product) {
  if (product.properties.has(_Integrations.PRODUCT_IDENTIFIERS.SHOPIFY)) {
    return _Integrations.INTEGRATION_SOURCES.SHOPIFY;
  } else if (product.properties.has(_Integrations.INTEGRATION_IDENTIFIERS.ECOMM)) {
    return _Integrations.INTEGRATION_SOURCES.ECOMM_API;
  }

  return _Integrations.INTEGRATION_SOURCES.HUBSPOT;
}

function sourceIsHubSpot(subject) {
  return !subject.properties.has(_ProductProperties.ECOMM_SYNCED);
}

function sourceIsEcommApi(subject) {
  return subject.properties.has(_ProductProperties.ECOMM_SYNCED) && !subject.properties.has(_ProductProperties.ECOMM_APP_ID);
}

function getDealSource(deal) {
  if (deal.properties.has(_Integrations.DEAL_IDENTIFIERS.SHOPIFY)) {
    return _Integrations.INTEGRATION_SOURCES.SHOPIFY;
  } else if (deal.properties.has(_Integrations.INTEGRATION_IDENTIFIERS.ECOMM)) {
    return _Integrations.INTEGRATION_SOURCES.ECOMM_API;
  }

  return _Integrations.INTEGRATION_SOURCES.HUBSPOT;
}

function getLineItemSource(lineItem) {
  /*
  Currently, a Shopify line item in a HubSpot deal does not contain any of the
  Shopify specific attributes. Therefore, we need to use a different method
  for differentiating the source of a line item.
  */
  if (lineItem.properties.has(_Integrations.LINE_ITEM_IDENTIFIERS.SHOPIFY)) {
    return _Integrations.INTEGRATION_SOURCES.SHOPIFY;
  } else if (lineItem.properties.has(_Integrations.INTEGRATION_IDENTIFIERS.ECOMM)) {
    return _Integrations.INTEGRATION_SOURCES.ECOMM_API;
  }

  return _Integrations.INTEGRATION_SOURCES.HUBSPOT;
}

function getProductDescriptionProperty(product) {
  switch (getProductSource(product)) {
    case _Integrations.INTEGRATION_SOURCES.SHOPIFY:
      return 'ip__shopify__body_html';

    case _Integrations.INTEGRATION_SOURCES.HUBSPOT:
      return _PropertyNames.DESCRIPTION;

    default:
      return _PropertyNames.DESCRIPTION;
  }
}

function getProductImageSource(product) {
  switch (getProductSource(product)) {
    case _Integrations.INTEGRATION_SOURCES.ECOMM_API:
    case _Integrations.INTEGRATION_SOURCES.SHOPIFY:
      return 'avatars';

    case _Integrations.INTEGRATION_SOURCES.HUBSPOT:
      return null;

    default:
      return null;
  }
}

function getProductTagsProperty(product) {
  switch (getProductSource(product)) {
    case _Integrations.INTEGRATION_SOURCES.SHOPIFY:
      return 'ip__shopify__tags';

    case _Integrations.INTEGRATION_SOURCES.HUBSPOT:
      return null;

    default:
      return null;
  }
}

function getLineItemDiscountProperty(lineItem) {
  switch (getLineItemSource(lineItem)) {
    case _Integrations.INTEGRATION_SOURCES.SHOPIFY:
      return 'ip__ecomm_bridge__discount_amount';

    case _Integrations.INTEGRATION_SOURCES.HUBSPOT:
      return _PropertyNames.DISCOUNT;

    default:
      return _PropertyNames.DISCOUNT;
  }
}

function getLineItemDiscountValue(lineItem) {
  var discount = (0, _ImmutableModel.getProperty)(lineItem, getLineItemDiscountProperty(lineItem));

  switch (getProductSource(lineItem)) {
    case _Integrations.INTEGRATION_SOURCES.SHOPIFY:
      return discount / (0, _ImmutableModel.getProperty)(lineItem, _PropertyNames.QUANTITY);

    case _Integrations.INTEGRATION_SOURCES.HUBSPOT:
      return discount;

    default:
      return discount;
  }
}

function getPriceProperty(lineItem) {
  switch (getLineItemSource(lineItem)) {
    case _Integrations.INTEGRATION_SOURCES.SHOPIFY:
      return lineItem.properties.has('amount') ? 'amount' : _PropertyNames.PRICE;

    case _Integrations.INTEGRATION_SOURCES.HUBSPOT:
      return _PropertyNames.PRICE;

    default:
      return _PropertyNames.PRICE;
  }
}

function getDealDiscountProperty(deal) {
  switch (getDealSource(deal)) {
    case _Integrations.INTEGRATION_SOURCES.SHOPIFY:
      return 'ip__ecomm_bridge__discount_amount';

    case _Integrations.INTEGRATION_SOURCES.HUBSPOT:
      return null;

    default:
      return null;
  }
}

function getDealSubtotalProperty(deal) {
  switch (getDealSource(deal)) {
    case _Integrations.INTEGRATION_SOURCES.SHOPIFY:
      return 'ip__shopify__subtotal_price';

    case _Integrations.INTEGRATION_SOURCES.HUBSPOT:
      return null;

    default:
      return null;
  }
}

function getDealTaxProperty(deal) {
  switch (getDealSource(deal)) {
    case _Integrations.INTEGRATION_SOURCES.SHOPIFY:
      return 'ip__ecomm_bridge__tax_amount';

    case _Integrations.INTEGRATION_SOURCES.HUBSPOT:
      return null;

    default:
      return null;
  }
}